/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Hasmigrationbackground_Label2Inputs */

const en_cv_extract_form_hasmigrationbackground_label2 = /** @type {(inputs: Cv_Extract_Form_Hasmigrationbackground_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migration history`)
};

const de_cv_extract_form_hasmigrationbackground_label2 = /** @type {(inputs: Cv_Extract_Form_Hasmigrationbackground_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuwanderungsgeschichte`)
};

/**
* | output |
* | --- |
* | "Migration history" |
*
* @param {Cv_Extract_Form_Hasmigrationbackground_Label2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_hasmigrationbackground_label2 = /** @type {((inputs?: Cv_Extract_Form_Hasmigrationbackground_Label2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Hasmigrationbackground_Label2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_hasmigrationbackground_label2(inputs)
	return en_cv_extract_form_hasmigrationbackground_label2(inputs)
});
export { cv_extract_form_hasmigrationbackground_label2 as "cv_extract_form_hasMigrationBackground_label" }